import { isZeroOffset, offsetText } from "./offset.ts";
import type { Offset } from "./offset.ts";
import type { Spot } from "./types.ts";

// One wording for a placement wherever a buyer reads it: the designer's request, the share page and the checkout quote.
export const SPOT_NAME: Record<Spot, string> = { "front-center": "Front center", "left-chest": "Left chest", "full-back": "Full back" };

// ", 1.5 in lower, 0.5 in left of standard as you face the shirt" when the logo moved within its spot, else nothing.
// Left and right are the viewer's (the offset is measured on the photo), not the wearer's as in "Left chest", so the
// press note says which.
export function offsetNote(o: Partial<Offset> | null | undefined): string {
  return isZeroOffset(o) ? "" : `, ${offsetWords(o)}`;
}

// "1.5 in lower, 0.5 in left of standard as you face the shirt", or "Standard position".
export function offsetWords(o: Partial<Offset> | null | undefined): string {
  return isZeroOffset(o) ? offsetText(o) : `${offsetText(o)} of standard as you face the shirt`;
}

// "Front center, 10 x 5 in", or "Left chest, 4 x 2 in, 1.5 in lower, 0.5 in left of standard as you face the shirt"
// when it moved.
export function placementText(p: { spot: Spot; widthIn: number; heightIn: number } & Partial<Offset>): string {
  return `${SPOT_NAME[p.spot]}, ${p.widthIn} x ${p.heightIn} in${offsetNote(p)}`;
}

// The share page's print size line: "Front center: 10 in wide by 5 in tall", or with the offset note after it when the
// logo moved. A spot it does not know keeps its own name.
export function printSizeLine(p: { spot: Spot; widthIn: number; heightIn: number } & Partial<Offset>): string {
  return `${SPOT_NAME[p.spot] ?? p.spot}: ${p.widthIn} in wide by ${p.heightIn} in tall${offsetNote(p)}`;
}
